
const storage = {
  async get (key) {
    return Promise.resolve().then(() => {
      return localStorage.getItem(key);
    });
  },
  async set (key, val) {
    return Promise.resolve().then(() => {
      localStorage.setItem(key, val);
    });
  },
  async delete (key) {
    return Promise.resolve().then(() => {
      localStorage.removeItem(key);
    });
  },
  async clear () {
    return Promise.resolve().then(() => {
      localStorage.clear();
    });
  },
  isSupported () {
    try {
      const testKey = '__test';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }
};

export default storage;
